import React, {Component, ReactElement} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {
    ContentsMainTitle,
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    IconFont,
    MainContainer,
} from '../../../styledComponents/ContentsArea'
import {StyledDiv, StyledI} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {generateMedia} from 'styled-media-query'
import {BreakPoint} from '../../../styledComponents/Constants'
import {BOARD_AUTHORITY, THREAD_CATEGORY} from '../../../CodeMaster'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {Location} from 'react-router-dom'

const KEY_BOARD_RESIDET_AUTHORITY = 'boardResidentAuthority'
const KEY_BOARD_ADMIN_AUTHORITY = 'boardAdminAuthority'

interface Props {
    location: Location
}


interface States {
    isLoadCompleted: boolean,
}

class NatResidentBulletinBoardPage extends Component<Props & ResidentPagePropsSet, States> {

    boardResidentAuthority: string
    boardAdminAuthority: string

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            isLoadCompleted: false,
        }

        this.boardResidentAuthority = SessionStorageHelper.getStringItemWithDefault(KEY_BOARD_RESIDET_AUTHORITY,
            BOARD_AUTHORITY.NONE.value)
        this.boardAdminAuthority = SessionStorageHelper.getStringItemWithDefault(KEY_BOARD_ADMIN_AUTHORITY,
            BOARD_AUTHORITY.NONE.value)

        this.clickResidentButton = this.clickResidentButton.bind(this)
        this.clickAdminButton = this.clickAdminButton.bind(this)
        this.judgeDispCategoryButton = this.judgeDispCategoryButton.bind(this)


    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {

        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    clickResidentButton(): void {
        this.props.navigate(`/resident/bulletinBoardThreadList/${THREAD_CATEGORY.RESIDENT.value}`)
    }

    clickAdminButton(): void {
        this.props.navigate(`/resident/bulletinBoardThreadList/${THREAD_CATEGORY.ADMIN.value}`)
    }

    judgeDispCategoryButton(boardAuthority: string): boolean {

        if (boardAuthority === BOARD_AUTHORITY.EDIT.value ||
            boardAuthority === BOARD_AUTHORITY.VIEW.value) {
            return true
        } else {
            return false
        }

    }


    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <ContentsMainTitle><TitleIcon/>情報交換掲示板</ContentsMainTitle>
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        カテゴリー
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                {(this.judgeDispCategoryButton(this.boardResidentAuthority) ||
                    this.judgeDispCategoryButton(this.boardAdminAuthority)) ?
                    <MainContainer>
                        <BulletinBoardCategoryList>
                            {(this.judgeDispCategoryButton(this.boardResidentAuthority)) ?
                                <BulletinBoardCategory onClick={this.clickResidentButton}>
                                    <BulletinBoardCategoryIcon>
                                        <BulletinBoardCategoryResidentIcon></BulletinBoardCategoryResidentIcon>
                                    </BulletinBoardCategoryIcon>
                                    <BulletinBoardCategoryLabel>
                                        {THREAD_CATEGORY.RESIDENT.label}
                                    </BulletinBoardCategoryLabel>
                                </BulletinBoardCategory> : <></>
                            }
                            {(this.judgeDispCategoryButton(this.boardAdminAuthority)) ?
                                <BulletinBoardCategory onClick={this.clickAdminButton}>
                                    <BulletinBoardCategoryIcon>
                                        <BulletinBoardCategoryAdminIcon></BulletinBoardCategoryAdminIcon>
                                    </BulletinBoardCategoryIcon>
                                    <BulletinBoardCategoryLabel>
                                        {THREAD_CATEGORY.ADMIN.label}
                                    </BulletinBoardCategoryLabel>
                                </BulletinBoardCategory> : <></>
                            }
                        </BulletinBoardCategoryList>
                    </MainContainer> : <></>
                }
            </>
        )
    }
}

export default createResidentPage(NatResidentBulletinBoardPage)

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

const TitleIcon: StyledI = styled.i`
  ${IconFont};
  font-size: 6.0rem;
  padding-right: 15px;
  color: #4dba78;

  &::before {
      content: "\f111";
  }
`

const BulletinBoardCategoryIcon: StyledDiv = styled.div`
  ${IconFont};
  font-size: 6.0rem;
  padding-right: 15px;
  color: #1b6cb3;
`

const BulletinBoardCategoryLabel: StyledDiv = styled.div`
  ${breakPoint.lessThan('sp')`
    padding-left: 15px;
  `}
`

const BulletinBoardCategoryResidentIcon: StyledI = styled.i`
  &::before {
      content: "\f111";
  }
`

const BulletinBoardCategoryAdminIcon: StyledI = styled.i`
  &::before {
      content: "\f128";
  }
`

const BulletinBoardCategoryList: StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
  box-sizing: inherit;
  align-items: flex-start;

  ${breakPoint.lessThan('sp')`
    flex-direction: column;
  `}

`

const BulletinBoardCategory: StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  width: 100%;
  text-align: center;
  position: relative;
  word-break: break-all;
  cursor: pointer;
  margin: 0 20px;

  ${breakPoint.lessThan('sp')`
    margin: 0;
    flex-direction: row;
    width: 100%;
    :not(:first-child){
      padding-top: 8px;
    }
  `}
`
